import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RecordQueryDataRecord } from '../../graphql/query/record.query'
import { ID } from '../../utils/id'


export type Record = {
  audio?: string
  authorId?: ID
  companyId?: ID
  created?: string
  duration?: number
  groupId?: ID
  id?: ID
  instanceEndDate?: string
  instanceId?: ID
  instanceStartDate?: string
  language?: string
  /** @deprecated use instanceEndDate */
  meetingEndDate?: string
  /** @deprecated use instanceEndDate */
  meetingId?: ID
  /** @deprecated use instanceEndDate */
  meetingName?: string
  /** @deprecated use instanceEndDate */
  meetingStartDate?: string
  name?: string
  restrictToPreview?: boolean
  scheduleName?: string
  secure?: boolean
  status?: string
  transcriptId?: ID
  updated?: string
}

export const recordSlice = createSlice({
  initialState: {} as Record,

  name: 'record',

  reducers: {
    clear: () => {
      return {} as Record
    },
    setRecord: (state, action: PayloadAction<RecordQueryDataRecord>) => {
      const record = action.payload

      return {
        audio: record.audio,
        authorId: record.author?.id,
        companyId: record.companyId,
        created: record.created,
        duration: record.duration,
        groupId: record.group?.id,
        id: record.id,
        instanceEndDate: record.instance?.endTime,
        instanceId: record.instance?.id,
        instanceStartDate: record.instance?.startTime,
        language: record.language,
        meetingEndDate: record.instance?.endTime,
        meetingId: record.instance?.id,
        meetingName: record.instance?.schedule.title,
        meetingStartDate: record.instance?.startTime,
        name: record.name,
        restrictToPreview: record.restrictToPreview,
        scheduleName: record.instance?.schedule.title,
        secure: record.secure,
        status: record.status,
        transcriptId: record.transcript?.id,
        updated: record.updated,
      } as Record
    },
    updateRecord: (state, action: PayloadAction<{
      name: string
      secure: boolean
      groupId: string
    }>) => {
      if (action.payload.name !== undefined) {
        state.name = action.payload.name
      }
      if (action.payload.secure !== undefined) {
        state.secure = action.payload.secure
      }
      if (action.payload.groupId !== undefined) {
        state.groupId = action.payload.groupId
      }

      return state
    },
  },
})

export const {updateRecord, setRecord, clear} = recordSlice.actions
